<ws-modal-wrapper (cancel)="cancel()" [excludeModalStyling]="true" [hideFooter]="true">
    @if (params?.dialogContext; as dialogContext) {
        <attachment-bundler
            [bundlerTarget]="dialogContext.bundlerSource"
            [invoiceContext]="dialogContext"
            (dialogCancel)="cancel()"
            (dialogSubmit)="onDialogSubmit($event)"
        >
        </attachment-bundler>
    }
</ws-modal-wrapper>
